import * as React from "react";
import {updateOrderState} from "../retry/fetchers";
import {orderToOrderIdentifier} from "../retry/interfaces";
import Alert from "../../../Common/Alert";
import {useState} from "react";
import { OrderStates } from "../../../../types/orders/order";
import { FeaturesAllowedName } from "../../../../utils/commonFetchers";

export default (props: any) => {
  const { dataItem } = props;
  const isRejectedOrder = dataItem.erpState.toLowerCase() === OrderStates.ENVIO_RECHAZADO || dataItem.erpState.toLowerCase() === OrderStates.ERROR_AL_ENVIAR;
  const featuresAllowedToAction = (props.featuresAllowed as string[]).find(x => x === FeaturesAllowedName.REJECTED_ORDER);
  const [success, setSuccess] = useState(true);
  const [text, setText] = useState('');
  const [show, setShow] = useState(false);
  const close = () => {
      setShow(false);
  }

  const orderIdentifier = orderToOrderIdentifier(dataItem);

  if (isRejectedOrder && featuresAllowedToAction)
  {
    return (
      <td className="k-command-cell">
        <Alert success={success} text={text} show={show} close={close}></Alert>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
          onClick={() => props.auditory(dataItem)}
        >
          Logs
        </button>
        <React.Fragment>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
            onClick={() => updateOrderState("REINTENTANDO ENVIO", [orderIdentifier])
                .then(x => {
                    const updateOrderStateSuccess = !(x.notUpdated > 0);

                    setSuccess(updateOrderStateSuccess);
                    setText(updateOrderStateSuccess ? "Actualizado Exitosamente" : x.error);
                    setShow(true);
                    props.requestNewPage();
                })}
          >
            Reintentar envio
          </button>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
            onClick={() => updateOrderState("CANCELADO", [orderIdentifier])
                .then(x => {
                    const updateOrderStateSuccess = !(x.notUpdated > 0);

                    setSuccess(updateOrderStateSuccess);
                    setText(updateOrderStateSuccess ? "Actualizado Exitosamente" : x.error);
                    setShow(true);
                    props.requestNewPage();
                })}
          >
              Cancelar
          </button>
        </React.Fragment>
      </td>
    );
  }
  else
  {
    return (
      <td className="k-command-cell">
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
          onClick={() => props.auditory(dataItem)}
        >
          Logs
        </button>
      </td>
    );
  }
};
